import React from 'react';
import { FadeIn } from './FadeIn';
import { ClipboardList, Users, Monitor, Settings } from 'lucide-react';
const pillars = [{
  icon: ClipboardList,
  title: 'Procesos claros',
  desc: 'La operación tiene lógica definida — no depende de que alguien recuerde cómo se hace.'
}, {
  icon: Users,
  title: 'Equipo con dirección',
  desc: 'Cada quien sabe qué hacer, por qué y hasta dónde puede decidir solo.'
}, {
  icon: Monitor,
  title: 'Tecnología que libera',
  desc: 'Las herramientas correctas, en el momento correcto, multiplicando los resultados correctos.'
}, {
  icon: Settings,
  title: 'Operación con lógica',
  desc: 'El negocio funciona cuando tú no estás — no solo sobrevive.'
}];
export function SolutionSection() {
  return <section className="py-24 px-6 bg-navy" data-id="element-111">
      <div className="max-w-5xl mx-auto" data-id="element-112">
        <div className="text-center mb-16" data-id="element-113">
          <FadeIn data-id="element-114">
            <h2 className="text-3xl md:text-5xl font-serif mb-8" data-id="element-115">
              La solución no es trabajar más. <br data-id="element-116" />
              <span className="text-gold" data-id="element-117">
                Es construir mejor — con estructura y tecnología integradas.
              </span>
            </h2>
          </FadeIn>
          <FadeIn delay={0.1} data-id="element-118">
            <p className="text-xl text-gray-light max-w-3xl mx-auto mb-10" data-id="element-119">
              Lo que necesitas es un sistema que sostenga el negocio sin
              fricción — donde la tecnología multiplica lo que ya funciona, no
              lo que está roto.
            </p>
          </FadeIn>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-16" data-id="element-120">
          {pillars.map((pillar, i) => {
          const Icon = pillar.icon;
          return <FadeIn key={i} delay={0.3 + i * 0.1} data-id="element-121">
                <div className="p-8 rounded-xl border border-gold bg-white/[0.02] hover:bg-white/[0.04] transition-colors flex flex-col items-center text-center h-full" data-id="element-122">
                  <div className="w-16 h-16 rounded-full bg-gold/10 flex items-center justify-center mb-6" data-id="element-123">
                    <Icon className="w-8 h-8 text-gold" data-id="element-124" />
                  </div>
                  <h3 className="text-2xl font-serif text-white mb-3" data-id="element-125">
                    {pillar.title}
                  </h3>
                  <p className="text-gray-light text-lg" data-id="element-126">{pillar.desc}</p>
                </div>
              </FadeIn>;
        })}
        </div>

        <FadeIn delay={0.6} data-id="element-127">
          <div className="text-center max-w-3xl mx-auto" data-id="element-128">
            <p className="text-lg md:text-xl text-gray-light leading-relaxed italic" data-id="element-129">
              "Estrategia, ingeniería y tecnología. Integradas. Para que tu
              negocio vuelva a estar alineado con lo que realmente importa."
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}